import { useState } from "react";
import { Outlet } from "react-router-dom";
import AtriumTopbar from "./AtriumTopbar";
import AtriumCommandPalette from "./AtriumCommandPalette";
import { useTweaks, ACCENT_HEX } from "./useTweaks";

export default function AtriumShell() {
  const [tweaks] = useTweaks();
  const [paletteOpen, setPaletteOpen] = useState(false);

  return (
    <div
      className={`atrium ${tweaks.theme === "light" ? "light" : ""}`}
      style={{
        fontSize: tweaks.density === "compact" ? 12 : 13,
        ["--a-accent" as string]: ACCENT_HEX[tweaks.accent],
      }}
    >
      <AtriumTopbar onSearch={() => setPaletteOpen(true)} />
      <div className="flex-1 flex overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <AtriumCommandPalette open={paletteOpen} setOpen={setPaletteOpen} />
    </div>
  );
}
